<template>
  <v-form class="mx-10 mb-10 pa-10 text-center">
    <h3 class="text-left mb-5 text-primary">Config Manager</h3>
    <v-layout>

      <v-row>
        <v-col cols="6">
          <v-col cols="12">
            <h4 class="text-left">Variables</h4>
          </v-col>
          <v-col cols="8">
            <v-text-field
              background-color="rgba(255,255,255)"
              v-model="serverURL"
              label="server URL"
              dense
              outlined
            ></v-text-field>
            <v-text-field
              background-color="rgba(255,255,255)"
              v-model="seat"
              label="Seat"
              dense
              outlined
            ></v-text-field>
            <v-text-field
              background-color="rgba(255,255,255)"
              v-model="tenant"
              label="Tenant"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="8"></v-col>
          <div class="d-flex">
            <v-col cols="8">
              <h4>Generation <span v-if="existsGenerationToken">(generated)</span></h4>
              <v-text-field
                background-color="rgba(255,255,255)"
                v-model="generationClientId"
                label="Client id"
                dense
                outlined
              ></v-text-field>
              <v-text-field
                background-color="rgba(255,255,255)"
                v-model="generationClientSecret"
                label="Client secret"
                type="password"
                dense
                outlined
              ></v-text-field>
              <v-text-field
                background-color="rgba(255,255,255)"
                v-model="generationGrantType"
                label="Grant Type"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <div class="d-flex align-center" style="height: 100%; width: 100%;">
                <v-btn
                  :disabled="generationGrantType == '' || generationClientId == '' || generationClientSecret == ''"
                  color="primary"
                  @click="updateGenerationToken"
                  style="color:white; width: 100%">
                  Generation >>
                </v-btn>
              </div>
            </v-col>
          </div>

          <div class="d-flex">
            <v-col cols="8">
              <h4>Usage <span v-if="existsUsageToken">(generated)</span></h4>
              <v-text-field
                background-color="rgba(255,255,255)"
                v-model="usageClientId"
                label="Client id"
                dense
                outlined
              ></v-text-field>
              <v-text-field
                background-color="rgba(255,255,255)"
                v-model="usageClientSecret"
                label="Client secret"
                type="password"
                dense
                outlined
              ></v-text-field>
              <v-text-field
                background-color="rgba(255,255,255)"
                v-model="usageGrantType"
                label="Grant Type"
                dense
                outlined
              ></v-text-field>
              <v-text-field
                background-color="rgba(255,255,255)"
                v-model="usageScope"
                label="Scope"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <div class="d-flex align-center" style="height: 100%; width: 100%;">
                <v-btn
                  :disabled="usageGrantType == '' || usageClientId == '' || usageClientSecret == ''"
                  color="primary"
                  @click="updateUsageToken"
                  style="color:white; width: 100%">
                  USAGE >>
                </v-btn>
              </div>
            </v-col>
          </div>
        </v-col>
        <v-col cols="6">
          <v-textarea background-color="rgba(255,255,255)"
          name="input-7-1"
          label="Response"
          no-resize
          height="550px"
          v-model="response"
          outlined
        ></v-textarea>
        </v-col>
      </v-row>

    </v-layout>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex';
import enviroment from '../enviroment.js';
import alisonServer from  '../services/alisonServer.js';
  export default {
    props:["data", "config", "serverConfig"],
    data: () => ({
      serverURL: enviroment.alisonServerApiUrl,
      generationClientId: enviroment.defaultServerGenerationClientId,
      generationClientSecret: enviroment.defaultServerGenerationClientSecret,
      generationGrantType: 'client_credentials',
      usageClientId: enviroment.defaultServerUsageClientId,
      usageClientSecret: enviroment.defaultServerUsageClientSecret,
      usageGrantType: 'client_credentials',
      usageScope: 'seat:12345678@acme',
      seat: 'botonera',
      response: '',
      tenant: 'acme',
      existsGenerationToken: false,
      existsUsageToken: false,
    }),
    mounted(){
      this.existsGenerationToken = this.serverConfig?.generationAccessToken !== undefined;
      this.existsUsageToken = this.serverConfig?.usageAccessToken !== undefined;
    },
    watch:{
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      async updateGenerationToken() {
        try {
          alisonServer.changeServerURL(this.serverURL);
          alisonServer.changeTenant(this.tenant);
          const tokenResponse = await alisonServer.updateGenerationToken(this.generationClientId, this.generationClientSecret);
          const seatId = await alisonServer.createSeat(this.seat);
          this.existsGenerationToken = true;
          this.$emit("setServerConfig", {
            generationAccessToken: tokenResponse.access_token,
            seatId,
            tenant: this.tenant,
            serverURL: this.serverURL,
          });
          this.response = JSON.stringify(tokenResponse, null, "\t");
        } catch (e) {
          console.log(e);
        }
      },
      async updateUsageToken() {
        try {
          alisonServer.changeServerURL(this.serverURL);
          alisonServer.changeTenant(this.tenant);
          const tokenResponse = await alisonServer.updateUsageToken(this.usageClientId, this.usageClientSecret, this.usageScope);
          this.existsUsageToken = true;
          this.$emit("setServerConfig", {
            usageAccessToken: tokenResponse.access_token,
            tenant: this.tenant,
            serverURL: this.serverURL,
          });
          this.$emit("enableTab", ["Sign Server"]);
          this.response = JSON.stringify(tokenResponse, null, "\t");
        } catch (e) {
          console.log(e);
        }
      },
    },
  }
</script>
